import React, { Component } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
// import StockChart from './StockChart.js';
// import Ad from './Ad';
// import DisplayStockPrice from '../dashboard/DisplayStockPrice.js';
import StockProfile from './StockProfile';
import InstitutionalHolder from '../dashboard/InstitutionalHolder';
import SpecificStockNews from './SpecificStockNews';
import StockGrade from './StockGrade';
import StockInsiderTrading from './StockInsiderTrading';
import StockEarningSurprises from './StockEarningSurprises';
// import StockAlgoDisplay from './StockAlgoDisplay';
// import PubSub from 'pubsub-js';
// import { Helmet } from "react-helmet";
// import { Link } from 'react-router-dom';
import ATSStockDetails from '../ats/ATSStockDetails';
import MediaQuery from 'react-responsive';
import StockPeers from './StockPeers';
import StockPriceTarget from './StockPriceTarget';
import StockUpgradeDowngrade from '../upgradeDowngrade/StockUpgradeDowngrade';
import StockSenateTrading from '../senateTrading/StockSenateTrading';

class StockQuote1 extends Component {
    constructor(props) {
        super(props);
        console.log('StockQuote1 constructor', this.props.symbol);
        this.state = {
            symbol: this.props.symbol,
            reload: false
        };
        console.log('symbol', this.props.symbol, this.state.symbol);
    }

    componentDidUpdate(nextProps) {
        console.log('StockQuote1 before if', nextProps.symbol, this.state.symbol);
        if (nextProps.symbol !== this.state.symbol) {
            this.setState({ symbol: nextProps.symbol, reload: true });
            console.log('StockQuote', this.state.symbol);
        }
    }

    render() {
        if (this.state.reload) {
            console.log('StockQuote1 Reloading...');
            this.setState({ reload: false });
            return (<div>Loading...</div>);
        }
        // let chartUrl = '/chart/' + this.state.symbol;
        return (

            <>
                <Container fluid className="p-2">
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <MediaQuery minWidth={501}>
                                <SpecificStockNews symbol={this.state.symbol} limit={20}/>
                            </MediaQuery>
                            <MediaQuery maxWidth={500}>
                                <SpecificStockNews symbol={this.state.symbol} limit={5}/>
                            </MediaQuery>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                            <Row>
                                <Col><StockProfile symbol={this.state.symbol} /></Col>
                            </Row>
                            {/* <Row>
                                <Col><StockPriceTarget symbol={this.state.symbol} limit={10} /></Col>
                            </Row>  */}
                            <Row>
                                <Col><StockPeers symbol={this.state.symbol} limit={200} /></Col>
                            </Row>     
                            <Row>
                                <Col><StockUpgradeDowngrade symbol={this.state.symbol} limit={10} /></Col>
                            </Row>                                                    
                            <Row>
                                <Col><StockGrade symbol={this.state.symbol} limit={15} /></Col>
                            </Row>
                            <Row>
                                <Col><StockEarningSurprises symbol={this.state.symbol} limit={4} /></Col>
                            </Row>
                            <Row>
                                <Col><ATSStockDetails symbol={this.state.symbol} limit={5} /></Col>
                            </Row>
                            <Row>
                                <Col><InstitutionalHolder symbol={this.state.symbol} limit={10} /></Col>
                            </Row>
                            <Row>
                                <Col><StockInsiderTrading symbol={this.state.symbol} limit={10} /></Col>
                            </Row>
                            <Row>
                                <Col><StockSenateTrading symbol={this.state.symbol} limit={10} /></Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default StockQuote1;
